var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('router-view',{attrs:{"name":"navigation"}}),_c('router-view'),_c('div',{staticClass:"blarp"},[_c('toastr')],1),_c('router-view',{attrs:{"name":"sidepanel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }